"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Info_exports = {};
__export(Info_exports, {
  default: () => Info_default
});
module.exports = __toCommonJS(Info_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M12 0.00415039C9.62663 0.00415039 7.30655 0.707938 5.33316 2.02652C3.35977 3.34509 1.8217 5.21924 0.913451 7.41195C0.00519943 9.60466 -0.232441 12.0175 0.230582 14.3452C0.693605 16.673 1.83649 18.8112 3.51472 20.4894C5.19295 22.1677 7.33115 23.3106 9.65892 23.7736C11.9867 24.2366 14.3995 23.999 16.5922 23.0907C18.7849 22.1825 20.6591 20.6444 21.9776 18.671C23.2962 16.6976 24 14.3775 24 12.0042C23.9966 8.82261 22.7312 5.77236 20.4815 3.52267C18.2318 1.27298 15.1815 0.00759147 12 0.00415039ZM12 22.0042C10.0222 22.0042 8.08879 21.4177 6.4443 20.3188C4.79981 19.22 3.51809 17.6582 2.76121 15.831C2.00433 14.0037 1.8063 11.9931 2.19215 10.0532C2.578 8.11344 3.53041 6.33161 4.92894 4.93308C6.32746 3.53456 8.10929 2.58215 10.0491 2.1963C11.9889 1.81045 13.9996 2.00848 15.8268 2.76536C17.6541 3.52223 19.2159 4.80396 20.3147 6.44845C21.4135 8.09294 22 10.0263 22 12.0042C21.9971 14.6554 20.9426 17.1973 19.0679 19.072C17.1931 20.9467 14.6513 22.0012 12 22.0042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M12 10.0042H11C10.7348 10.0042 10.4804 10.1095 10.2929 10.297C10.1054 10.4846 10 10.7389 10 11.0042C10 11.2694 10.1054 11.5237 10.2929 11.7113C10.4804 11.8988 10.7348 12.0042 11 12.0042H12V18.0042C12 18.2694 12.1054 18.5237 12.2929 18.7113C12.4804 18.8988 12.7348 19.0042 13 19.0042C13.2652 19.0042 13.5196 18.8988 13.7071 18.7113C13.8946 18.5237 14 18.2694 14 18.0042V12.0042C14 11.4737 13.7893 10.965 13.4142 10.5899C13.0391 10.2149 12.5304 10.0042 12 10.0042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M12 8.00415C12.8284 8.00415 13.5 7.33258 13.5 6.50415C13.5 5.67572 12.8284 5.00415 12 5.00415C11.1716 5.00415 10.5 5.67572 10.5 6.50415C10.5 7.33258 11.1716 8.00415 12 8.00415Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgInfo = SvgIcon;
var Info_default = SvgInfo;
//# sourceMappingURL=Info.js.map